import * as React from 'react';
import { Link as MatLink, linkClasses, SxProps, Theme } from '@mui/material';
import { archerConstants } from '../../utils/themeProvider';

type LinkColor = 'primary' | 'secondary' | 'inherit' | 'default';
type LinkUnderline = 'none' | 'hover' | 'always';
type LinkVariants = 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6' | 'subtitle1' | 'subtitle2' | 'body2' | 'body1' | 'caption' | 'button' | 'overline';

const styles: Record<string, SxProps<Theme>> = {
  linkRoot: {
    cursor: 'pointer',
    '&:hover': {
      outline: 'none',
      textDecoration: 'underline'
    },
    '&:focus': {
      outline: 'none',
      textDecoration: 'underline'
    }
  },
  linkRootDisabled: {
    pointerEvents: 'none' as 'none',
    color: 'text.disabled',
    [`&.${linkClasses['underlineAlways']}`]: {
      textDecorationColor: archerConstants.archerDisabled
    }
  }
};

export interface LinkProps {
  color?: LinkColor;
  component?: any;
  underline?: LinkUnderline;
  variant?: LinkVariants;
  onClick?: (event: React.MouseEvent<HTMLElement, MouseEvent>) => void;
  className?: string;
  disabled?: boolean;
  classes?: any;
  sx?: SxProps<Theme>;
}

const Link: React.FC<LinkProps> = ({ children, disabled, color, component, className, sx, ...rest }) => {
  const { linkRoot, linkRootDisabled } = styles;
  return (
    <MatLink
      sx={[disabled ? linkRootDisabled : linkRoot, sx] as SxProps<Theme>}
      color={color as any}
      component={component}
      {...rest}
      className={className ? className : ''}
      tabIndex={0}
    >
      {children}
    </MatLink>
  );
};

Link.displayName = 'Link';

export { Link };
